import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useTranslation } from '../../context/I18nContext';

const { FiSearch } = FiIcons;

export const MarketplaceSearch = ({ searchQuery, setSearchQuery }) => {
  const { t } = useTranslation();

  return (
    <div className="relative w-full max-w-2xl mx-auto">
      <div className="relative group">
        <div className="absolute inset-y-0 left-7 flex items-center pointer-events-none">
          <SafeIcon 
            icon={FiSearch} 
            className="w-6 h-6 text-zinc-400 group-focus-within:text-[#D4B483] transition-colors duration-300" 
          />
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={t('marketplace.searchPlaceholder')}
          className="w-full h-[68px] pl-16 pr-8 bg-white/95 backdrop-blur-xl border-0 rounded-[2rem] text-zinc-900 placeholder:text-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#D4B483]/30 transition-all duration-500 shadow-[0_20px_50px_-12px_rgba(0,0,0,0.08)] text-lg font-medium"
        />
      </div>
    </div>
  );
};